import * as React from 'react';
import { LinePath as VisxLinePath } from '@visx/shape';
import { curveLinear } from '@visx/curve';
import { LinePathProps as VisxLinePathProps } from '@visx/shape/lib/shapes/LinePath';
import { useTheme, useThemeRawValues } from '@leagueplatform/genesis-core';

export type LinePathProps<Datum> = VisxLinePathProps<Datum>;

/**
 * Wraps the visx LinePath component and applies genesis styles.
 */
export function LinePath<Datum>(props: LinePathProps<Datum>) {
  const theme = useTheme();
  const rawTheme = useThemeRawValues();

  return (
    <VisxLinePath
      stroke={
        theme.colors.dataVizSingleColorBrand ??
        theme.colors.decorativeBrandPrimaryDark
      }
      strokeWidth={rawTheme.space.quarter}
      curve={curveLinear}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}
